import React from 'react'
import axios from 'axios'
import { hydrateRoot } from 'react-dom/client'
import App from './App'

function getQueryParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const params = {};
  
  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  
  return params;
}

const get = getQueryParams();

// Данные приходят от SSR через window.__MODX_DATA__ (вставляются в server.js).
// Если их нет (прямое обращение / старый кэш) — делаем fallback-запрос, как раньше.
let ajax_data = {}
let data = {}
if (window.__MODX_DATA__) {
  ajax_data = window.__MODX_DATA__.ajax_data || {}
  data = window.__MODX_DATA__.data || {}
} else {
  const response_page = await axios.post(`https://brunoaltro.ru${window.location.pathname}`, {
    content_type: 'application/json',
    action: 'load_page_data',
    get: get
  }, {
    timeout: 5000,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Request-Source': 'Node.js'
    }
  })
  ajax_data = response_page?.data || {}
  data = ajax_data?.site_data || {}
  delete ajax_data['site_data']
}

hydrateRoot(
  document.getElementById('brunoaltro'),
  <App
    ajax_data={ajax_data}
    data={data}
    get={get}
  />
)